// extracted by mini-css-extract-plugin
module.exports = {"MenuSection":"MenuSection_MenuSection__2x_jC"};